define('samplesTabs',[
  'module',
  'underscore'
], function(
  module,
  _
) {
  'use strict';

  module.exports = [
    {
      name: 'detail',
      title: _.i18n('sample.details.tabTitle')
    },
    {
      name: 'smpres',
      title: _.i18n('sample.smpres.tabTitle')
    }
  ];
});
